import React from "react";
// import { Link } from "react-scroll";
import Pagetitle from "../elements/Pagetitle";
import Service from "../elements/Service";

const servicesData = [
  {
    id: 1,
    icon: "images/soft-service.svg",
    title: "Software Development",
    content:
      "Coming Soon...",
    color: "#6C6CE5",
    contentColor: "light",
    // 6C6CE5
  },
  {
    id: 2,
    icon: "images/service-2.svg",
    title: "Backend Development",
    content:
      "Coming Soon...",
    color: "#F9D74C",
    contentColor: "dark",
  },
  {
    id: 3,
    icon: "images/data-service.svg",
    title: "Data Analysis",
    content:
      "Coming Soon...",
    color: "#F97B8B",
    contentColor: "light",
  },
];

function Services() {
  return (
    <section id="services">
      <div className="container">
        <Pagetitle title="Career Track" />
        <div className="row fix-spacing">
          {servicesData.map((service) => (
            <div className="col-md-4" key={service.id}>
              <Service service={service} />
            </div>
          ))}
        </div>
        <div className="mt-5 text-center">
          <p className="mb-0">
            My programming tutorials and blogs on{" "}
            <a className="colorpink pointer" href="https://www.youtube.com/c/CodeAlap" 
            target="_blank" rel="noreferrer">Code Alap</a>{" "}&#x1F393;
            {/* Looking for a custom job?{" "}
            <Link
              className="colorpink pointer"
              to="section-contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              Click here
            </Link>{" "}
            to contact me! 👋 */}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
